import React, { useEffect, useState } from 'react'
import { useController, useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import CaluFormInput from '@/components/formComponents/customFields/CaluFormInput'
import CaluButton from '@/components/styledComponents/CaluButton'
import { handleSetCountryCode } from '@/utils/functions/handleSetCountryCode'
import { handleSetDniLabel } from '@/utils/functions/handleSetDniLabel'
import { Grid } from '@mui/material'

import s from '../styles.module.scss'

export const FormContent = ({ isLoading = false, showErrorPasswords, requestError, setRequestError }) => {
  const [countryCode, setCountryCode] = useState('549')
  const [dniLabel, setDniLabel] = useState('DNI')
  const centreDetail = useSelector((state) => state?.centres?.centreProfile)
  const COUNTRY = centreDetail?.country || import.meta.env.REACT_APP_COUNTRY
  const watchCountry = useWatch({ name: 'country', defaultValue: COUNTRY })
  const watchEmail = useWatch({ name: 'email' })
  const watchPassword = useWatch({ name: 'password' })
  const watchDni = useWatch({ name: 'dni' })

  const { field: patientDni } = useController({ name: 'dni' })
  const { field: fieldCountry } = useController({ name: 'country' })

  useEffect(() => {
    if (patientDni.value.length === 15) {
      patientDni.onChange('')
    }
    if (COUNTRY) fieldCountry.onChange(COUNTRY)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const countryCode = handleSetCountryCode(watchCountry)
    const dniLabel = handleSetDniLabel(watchCountry)
    if (countryCode) setCountryCode(countryCode)
    if (dniLabel) setDniLabel(dniLabel)
  }, [watchCountry])

  useEffect(() => {
    if (requestError) {
      setRequestError(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchDni, watchEmail, watchPassword])

  return (
    <div className={s.container}>
      <div className={s.loginTitleContainer}>
        <div className={s.loginTitle}>Crea tu cuenta en Calu</div>
      </div>
      <Grid container spacing={2} className={s.bodyCard}>
        <Grid item md={12} className={s.subtitle}>
          Datos personales
        </Grid>
        <Grid item xs={12} md={6}>
          <CaluFormInput labelText="Nombre(s) *" name="firstname" className={s.width98} autoFocus />
        </Grid>
        <Grid item xs={12} md={6}>
          <CaluFormInput labelText="Apellido(s) *" name="lastname" className={s.width98} />
        </Grid>
        <Grid item xs={12} md={6} className={s.containerInputDI}>
          <CaluFormInput
            labelText={`${dniLabel} *`}
            name="dni"
            className={s.width98}
            type="DI"
            helperText="DNI, Pasaporte, Licencia u otro documento."
            helperTextClassName={s.inputDI}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CaluFormInput
            labelText="Celular *"
            name="mobile"
            type="number"
            className={s.width98}
            countryCode={countryCode}
          />
        </Grid>
        <Grid item md={12} className={s.subtitle}>
          Datos de ingreso
        </Grid>
        <Grid item xs={12} md={12}>
          <CaluFormInput labelText="Email *" type="text" name="email" className={s.width98} />
        </Grid>
        <Grid item xs={12} md={6}>
          <CaluFormInput labelText="Contraseña *" name="password" type="password" className={s.width98} />
        </Grid>
        <Grid item xs={12} md={6}>
          <CaluFormInput labelText="Repite contraseña *" name="repitePassword" type="password" className={s.width98} />
        </Grid>
        {showErrorPasswords && (
          <div className={s.containerShowErrors}>
            <b>Las contraseñas deben coincidir</b>
            <b>Vuelve a intentarlo o escribenos por el Chat para que te ayudemos</b>
          </div>
        )}

        <div className={s.buttonContainer}>
          {requestError && (
            <div className={s.containerLinkLogin}>
              <div className={s.existingEmailText}>El mail ya está registrado</div>
              <div>
                <span>¿Ya tenes cuenta? </span>
                <span>
                  <Link to={'/ingresar'} className={s.linkLogin}>
                    Ingresá aquí
                  </Link>
                </span>
              </div>
            </div>
          )}
          <div>
            <CaluButton color="primary" type="submit" size="large" loading={isLoading}>
              Registrarme
            </CaluButton>
          </div>
        </div>
      </Grid>
    </div>
  )
}
